module.exports = __webpack_public_path__ + "media/images/country_flags/bo-6ed63ed39cee50b0a8a017a8df523239.png";